import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const FormSection = ({ title, inputs }) => (
  <div className={'FormSection'}>
    <div className={'FormSection__Top'}>
      <span className={'FormSection__Title '}>
        {title}
      </span>
    </div>
    <div className={'FormSection__Content'}>
      {inputs}
    </div>
  </div>
);

FormSection.propTypes = {
  title: PropTypes.string.isRequired,
  inputs: PropTypes.element.isRequired,
}

export default FormSection;
